
export interface YourPersonalDetails {
    title: string;
    otherTitle: string;
    forename: string;
    surname: string;
    middleName: string;
    thirdName: string;
    dateOfBirth: string;
    emailAddress: string;
    confirmEmailAddress: string;
    gender: string;
    maritalStatus: string;
    address: {
        line1: string;
        line2: string;
        line3: string;
        line4: string;
        postcode: string;
    };
    mobilePhone: string;  
    homePhone: string;
    nino: string;
    internalSoftOptInInd?:string;
    
}
